import React, { useContext, FormEvent, FunctionComponent } from 'react';
import Select from 'react-select';

import { SelectionValue } from '@components/library/inputs/Input.props';

import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';

import { CustomFieldKeysResponseObject } from '@api/v4/resources/CustomFieldKeysTypes';

import {
  ActionTypes,
  FlatCustomFieldMaps,
  UpdateCustomFieldsDispatch,
} from '@components/asset/modal/tabs/edit/EditTabTypes';

interface CustomFieldValueProps {
  controlledCustomFieldsEnabled: boolean;
  customFieldKey: CustomFieldKeysResponseObject;
}

interface CustomFieldKeyValueScopedContext {
  state: {
    editState: {
      customFieldMaps: FlatCustomFieldMaps[];
    };
  };
  dispatch: UpdateCustomFieldsDispatch;
}

/* eslint-disable @typescript-eslint/camelcase */
const CustomFieldValue: FunctionComponent<CustomFieldValueProps> = ({
  customFieldKey,
  controlledCustomFieldsEnabled
}) => {
  const { state, dispatch }: CustomFieldKeyValueScopedContext = useContext(assetModalContext);
  const { allowed_values, restricted } = customFieldKey.attributes;

  // we look up customFieldMaps for entry whose key.id matches the
  // passed in custom field key id
  // representings existing custom field value
  const existingCustomFieldMap: FlatCustomFieldMaps | undefined = state.editState.customFieldMaps.find((field) => field.key.id === customFieldKey.id);
  const generateSelectOptions = (optionsArray: string[]): SelectionValue[] => optionsArray.map((option) => ({ value: option, label: option }));

  const updateCustomFieldMaps = ({ value }: { value: string }): void => {
    // if map exists, allow empty values
    // as that triggers a delete on submit
    // otherwise, only create new map value if there is actual data
    if (existingCustomFieldMap || value) {
      dispatch({ type: ActionTypes.UpdateCustomFieldMaps, payload: { key: customFieldKey, value } });
    }
  };
  return (
    <div className="custom-field-value editable">
      {
        controlledCustomFieldsEnabled && restricted
          ? (
            <Select
              name="select-controlled-custom-field"
              className="controlled-custom-field-dropdown"
              value={existingCustomFieldMap?.value ? existingCustomFieldMap.value.value : ''}
              options={generateSelectOptions(allowed_values)}
              clearable
              placeholder={bfTranslate("Select value")}
              onChange={(selected): void => updateCustomFieldMaps({ value: selected ? selected.value : '' })}
            />
          ) : (
            <input
              aria-label="custom field value"
              className="custom-field-input"
              placeholder={bfTranslate("Enter value here")}
              value={existingCustomFieldMap?.value ? existingCustomFieldMap.value.value : ''}
              onChange={(e: FormEvent<HTMLInputElement>): void => updateCustomFieldMaps({ value: e.currentTarget.value })}
            />
          )
      }
    </div>
  );
};

export default CustomFieldValue;
